import {
  LidarTechnologyCreate,
  LidarTechnologyEdit,
  LidarTechnologyList,
} from '@/admin/resources/lidarTechnology/LidarTechnology';

export default {
  list: LidarTechnologyList,
  edit: LidarTechnologyEdit,
  create: LidarTechnologyCreate,
};
